module.exports = __webpack_public_path__ + "media/images/Group 15-b4907b72695c19cdac223840694c6717.png";